export default __webpack_public_path__ + "static/media/intern-font.b4fc9e6a.svg";